export const appendUtmParams = (url, utmParams) => {
  if (!url) return url
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}${utmParams}`
}
